<template>
  <v-card>
    <ClassTable />
  </v-card>
</template>

<script>
import ClassTable from './ClassTable.vue'
export default {
  components: { ClassTable },
}
</script>

<style></style>
